import RohwerData from "../../../../src/components/rohwer-data";
import * as React from 'react';
export default {
  RohwerData,
  React
};